<template>
  <div>
    <!--添加用户-->
    <el-dialog :visible.sync="addUserDialogVisible" title="添加用户" @close="feedBack" v-if="addUserDialogVisible">
      <el-form :label-position="labelPosition" label-width="130px" :model="AddUser.params" :ref="AddUser.params" :rules="rulesOfAddUser">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="AddUser.params.username" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户持有者姓名" prop="name">
          <el-input v-model="AddUser.params.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="AddUser.params.password" clearable></el-input>
        </el-form-item>
        <el-form-item label="电话号码" prop="phoneNumber">
          <el-input v-model="AddUser.params.phoneNumber" clearable></el-input>
        </el-form-item>
        <el-form-item label="初始用户组" prop="role">
          <el-select v-model="AddUser.params.role" style="width: 100%" clearable>
            <el-option :value="0" label="超级管理员"></el-option>
            <el-option :value="1" label="普通管理员"></el-option>
            <el-option :value="2" label="维修人员"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账户信息文件" >
          <el-upload
            class="upload-demo"
            drag
            action="https://jsonplaceholder.typicode.com/posts/"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处,或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="feedBack">取 消</el-button>
        <el-button type="primary" @click="checkAddUser">确定添加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AddUser',
  props:['addUserDialogVisible'],
  data(){
    return {
      rulesOfAddUser:{
        username: [{required: true, message:'用户名不能为空', trigger: 'change'}],
        password: [{required: true, message:'密码不能为空', trigger: 'change'}],
        name: [{required: true, message:'用户持有者姓名不能为空', trigger: 'change'}],
        role: [{required: true, message:'初始用户组不能为空', trigger: 'change'}],
        phoneNumber: [{required: true, message:'电话号码不能为空', trigger: 'change'}],
      },
      // 添加用户
      AddUser:{
        "version": 1,
        "method": "user.AddUser",
        "params": {
          "username": "",
          "password": "",
          "name":"",
          "role":"",
          "phoneNumber":""
        },
        "token": "",
        "id": 0
      }
    }
  },
  methods: {
    checkAddUser(){
      this.$refs[this.AddUser.params].validate((valid)=>{
        if(valid){
          this.addUser();
        }
        else{
          return false;
        }
      })
    },
    // 添加用户
    addUser(){
      for (let key in this.AddUser.params){
        if (this.AddUser.params[key] === ""){
          this.AddUser.params[key] = null;
        }
      }
      this.AddUser.token = this.$store.state.token;
      console.log('添加用户请求');
      console.log(this.AddUser);
      this.$axios.post(this.$mainUrl, this.AddUser).then(res =>{
        console.log('添加用户请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message:'添加用户成功'
          })
          this.feedBack();
        }else{
          this.$message({
            type:'error',
            message:'添加用户失败，' + res.data.error.message
          })
        }
      })
    },
    feedBack () {
      this.resetValidate(this.AddUser.params);
      this.cleanArguments(this.AddUser.params);
      this.addUserDialogVisible = false;
      this.$emit('feedBack',this.addUserDialogVisible);
    },

  }
}
</script>

<style scoped>

</style>
